// eslint-disable-next-line import/prefer-default-export
export const UserRole = {
  Buyer: 'Buyer',
  Seller: 'Seller',
  Pro: 'Pro',
  HomeOwner: 'Owner',
  AdditionalTitleHolder: 'ATH',
  Realtor: 'realtor',
};

export const BusinessUserRole = {
  Pro: 'Prō',
  Builder: 'Builder',
  Realtor: 'Realtor',
  Contractor: 'Contractor',
};

export const UserMotivation = {
  Buy: 'Buy',
  Sell: 'Sell',
  Pro: 'Pro',
  SeeSoldData: 'See sold data',
  UseProMarketPlace: 'Use Pro Marketplace',
};

export const UserAttribute = {
  Email: 'email',
  Password: 'password',
  SignUpDestination: 'destination',
};
